<template>
  <div class="transfer-container">
    <!-- 移动端遮罩层 -->
    <div 
      v-if="isMobile && isMobileMenuOpen" 
      class="sidebar-overlay"
      :class="{ show: isMobileMenuOpen }"
      @click="toggleMobileMenu">
    </div>

    <!-- 移动端拖拽菜单按钮 -->
      <div 
        v-if="isMobile" 
        class="drag-menu-button"
        :class="{ dragging: isDragging }"
        @click="handleMenuClick"
        @touchstart="handleDragStart"
        @touchmove="handleDragMove"
        @touchend="handleDragEnd"
        @mousedown="handleDragStart"
      >
        <i class="el-icon-menu"></i>
      </div>



    <!-- 左侧菜单栏 - 1/3宽度 -->
    <div class="sidebar" :class="{ open: isMobile && isMobileMenuOpen }">
      <div class="sidebar-header">
        <h3>设备来源</h3>
        <button 
          v-if="isMobile" 
          class="sidebar-toggle"
          @click="toggleMobileMenu">
          <i class="el-icon-close"></i>
        </button>
      </div>
      <div class="sidebar-menu">
        <div
          v-for="source in menuSources"
          :key="source.key"
          :class="['menu-item', { active: activeMenu === source.key }]"
          @click="selectMenu(source.key)">
          <i :class="source.icon"></i>
          <span>{{ source.label }}</span>
        </div>
      </div>
    </div>

    <!-- 右侧主内容区域 - 2/3宽度 -->
    <div class="main-content" :class="{ 'has-menu': isMobile }">
      <!-- 顶部标题栏 -->
      <!-- <div class="header">
        <div class="header-left">
          <h1>设备划拨</h1>
        </div>
        <p class="subtitle">请选择设备来源并划拨到目标店铺</p>
      </div> -->

      <!-- 设备来源指示器（移动端） -->
      <!-- <div v-if="isMobile" class="source-indicator">
        当前来源: {{ getMenuTitle(activeMenu) }}
      </div> -->

      <!-- 主要内容区 -->
      <div class="content">
        <div class="transfer-card">
          <div class="card-header">
            <h3>{{ getMenuTitle(activeMenu) }}</h3>
          </div>
          
          <!-- 设备划拨界面 -->
          <template v-if="activeMenu !== 'sd'">
            <el-form :model="form" ref="transferForm" label-position="top">
              <!-- 店铺选择 -->
              <el-form-item label="目标店铺" prop="shopId" required>
                <el-select
                  v-model="form.shopId"
                  :placeholder="shopLoading ? '正在加载店铺数据...' : '搜索或选择店铺'"
                  filterable
                  :filter-method="searchShops"
                  :loading="shopLoading"
                  :disabled="shopLoading"
                  class="full-width"
                  no-data-text="暂无数据">
                  <el-option
                    v-for="shop in shopOptions"
                    :key="shop.id"
                    :label="shop.name"
                    :value="shop.id">
                    <div class="shop-option">
                      <div class="shop-info">
                        <span class="shop-name">{{ shop.name }}</span>
                        <span v-if="shop.userName" class="shop-user">用户: {{ shop.userName }}</span>
                        <span v-if="shop.phone" class="shop-phone">手机: {{ shop.phone }}</span>
                      </div>
                      <span class="shop-id">ID: {{ shop.id }}</span>
                    </div>
                  </el-option>
                  <template slot="empty">
                    <div v-if="shopLoading" class="loading-empty">
                      <i class="el-icon-loading"></i>
                      <span>正在加载店铺数据...</span>
                    </div>
                    <div v-else class="empty-data">
                      <i class="el-icon-warning"></i>
                      <span>暂无店铺数据</span>
                    </div>
                  </template>
                </el-select>
              </el-form-item>

              <!-- 设备类型选择（仅saas和纷享时光显示） -->
              <el-form-item 
                v-if="activeMenu === 'saas' || activeMenu === 'fxsg'"
                label="设备类型" 
                prop="deviceType" 
                required>
                <el-radio-group v-model="form.deviceType" class="device-type-group">
                  <el-radio label="board" class="device-type-radio">
                    <i class="el-icon-cpu"></i>
                    智控主板
                  </el-radio>
                  <el-radio label="qiu" class="device-type-radio">
                    <i class="el-icon-lock"></i>
                    锁球器
                  </el-radio>
                </el-radio-group>
              </el-form-item>

              <!-- 设备输入 -->
              <el-form-item prop="deviceNumbers">
                <template #label>
                  <div class="device-header-row">
                    <div class="device-label-group">
                      <span class="required-mark">*</span>
                      <span class="device-label-text">设备编号</span>
                    </div>
                    <div class="device-count-wrapper">
                      <span class="device-count-badge">{{ deviceCount }} 个设备</span>
                    </div>
                  </div>
                </template>
                <div class="device-input-container">
                  <div class="scan-section">
                    <el-button
                      type="primary"
                      size="small"
                      @click="handleScan"
                      :loading="scanLoading"
                      class="scan-btn">
                      <i class="el-icon-camera"></i>
                      扫码添加设备
                    </el-button>
                  </div>
                  <el-input
                    type="textarea"
                    :rows="isMobile ? 4 : 6"
                    v-model="form.deviceNumbers"
                    @input="autoResizeTextarea"
                    ref="deviceInput"
                    placeholder="请输入设备编号
每行一个设备，例如：
SN1234567890
SN0987654321
SN1122334455
支持扫码、批量输入"
                    maxlength="1000"
                    show-word-limit
                    class="device-input">
                  </el-input>
                </div>
                <div class="input-tips">
                  <i class="el-icon-info"></i>
                  <span>支持扫码、批量输入，每行一个设备编号，无需分隔符</span>
                </div>
              </el-form-item>

              <!-- 操作按钮 -->
              <el-form-item>
                <div class="action-buttons">
                  <el-button
                    type="primary"
                    @click="handleTransfer"
                    :loading="transferLoading"
                    class="transfer-btn"
                    size="large">
                    <i class="el-icon-position"></i>
                    立即划拨
                  </el-button>
                  <el-button
                    @click="handleReset"
                    class="reset-btn"
                    size="large">
                    <i class="el-icon-refresh"></i>
                    重置
                  </el-button>
                </div>
              </el-form-item>
            </el-form>
          </template>
          
          <!-- 设备送电界面 -->
          <template v-else>
            <el-form :model="form" ref="transferForm" label-position="top">
              <!-- 设备输入 -->
              <el-form-item prop="deviceNumbers">
                <template #label>
                  <div class="device-header-row">
                    <div class="device-label-group">
                      <span class="required-mark">*</span>
                      <span class="device-label-text">设备编号</span>
                    </div>
                    <div class="device-count-wrapper">
                      <span class="device-count-badge">{{ deviceCount }} 个设备</span>
                    </div>
                  </div>
                </template>
                <div class="device-input-container">
                  <div class="scan-section">
                    <el-button
                      type="primary"
                      size="small"
                      @click="handleScan"
                      :loading="scanLoading"
                      class="scan-btn">
                      <i class="el-icon-camera"></i>
                      扫码添加设备
                    </el-button>
                    <span class="device-counter">
                      {{ deviceCount }} 个设备
                    </span>
                  </div>
                  <el-input
                    type="textarea"
                    :rows="isMobile ? 4 : 6"
                    v-model="form.deviceNumbers"
                    @input="autoResizeTextarea"
                    ref="deviceInput"
                    placeholder="请输入设备编号
每行一个设备，例如：
SN1234567890
SN0987654321
SN1122334455
支持扫码、批量输入"
                    maxlength="50000"
                    show-word-limit
                    class="device-input">
                  </el-input>
                </div>
                <div class="input-tips">
                  <i class="el-icon-info"></i>
                  <span>支持扫码、批量输入，每行一个设备编号，无需分隔符</span>
                </div>
              </el-form-item>

              <!-- 操作按钮 -->
              <el-form-item>
                <div class="action-buttons">
                  <el-button
                    type="primary"
                    @click="handlePowerOn"
                    :loading="powerOnLoading"
                    class="transfer-btn"
                    size="large">
                    <i class="el-icon-lightning"></i>
                    立即送电
                  </el-button>
                  <el-button
                    @click="handleReset"
                    class="reset-btn"
                    size="large">
                    <i class="el-icon-refresh"></i>
                    重置
                  </el-button>
                </div>
              </el-form-item>
            </el-form>
          </template>

          <!-- 结果显示 -->
          <div v-if="transferResult || powerOnResult" class="result-card">
            <div class="result-header">
              <i :class="getResultIcon((transferResult && transferResult.type) || (powerOnResult && powerOnResult.type))"></i>
              <span>{{ (transferResult && transferResult.title) || (powerOnResult && powerOnResult.title) }}</span>
            </div>
            <div class="result-content">
              <p>{{ (transferResult && transferResult.message) || (powerOnResult && powerOnResult.message) }}</p>
              <div v-if="(transferResult && transferResult.details) || (powerOnResult && powerOnResult.details)" class="result-details">
                <el-divider></el-divider>
                <pre>{{ (transferResult && transferResult.details) || (powerOnResult && powerOnResult.details) }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 验证码弹窗 -->
    <el-dialog
      :visible.sync="captchaDialogVisible"
      title="请输入验证码"
      :width="isMobile ? '90%' : '30%'"
      :before-close="handleCaptchaClose"
      :show-close="false">
      
      <div class="captcha-dialog">
        <el-form :model="{ captchaCode: this.captchaCode }" ref="captchaForm" label-position="top">
          <el-form-item label="验证码" prop="captchaCode" :error="captchaError">
            <el-input
              v-model="captchaCode"
              placeholder="请输入验证码"
              maxlength="6"
              show-word-limit
              @keyup.enter.native="verifyCaptchaAndTransfer"
              :autofocus="true">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="captchaDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="verifyCaptchaAndTransfer">确认</el-button>
      </span>
    </el-dialog>
    
    <!-- 设备送电时长选择弹窗 -->
    <el-dialog
      :visible.sync="powerOnDialogVisible"
      title="选择送电时长"
      :width="isMobile ? '90%' : '30%'"
      :before-close="handlePowerOnDialogClose"
      :show-close="false">
      
      <div class="duration-dialog">
        <div class="duration-options">
          <div 
            v-for="duration in [5, 10, 30, 60, 120, 180, 240, 300, 480, 720]" 
            :key="duration"
            class="duration-option"
            @click="handleDurationSelect(duration)">
            {{ getDurationText(duration) }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fenxShop, fenxDevice, batchOpen } from '@/api/device'

export default {
  name: 'DeviceTransfer',
  data() {
    return {
      activeMenu: 'saas',
      menuSources: [
        { key: 'saas', label: 'SaaS', icon: 'el-icon-s-platform' },
        { key: 'share', label: '共享设备', icon: 'el-icon-share' },
        { key: 'fxsg', label: '纷响时光', icon: 'el-icon-time' },
        { key: 'wsb', label: '外送帮', icon: 'el-icon-truck' },
        { key: 'ts', label: '他说设备', icon: 'el-icon-chat-dot-round' },
        { key: 'sd', label: '设备送电', icon: 'el-icon-lightning' },
      ],
      form: {
        shopId: '',
        deviceNumbers: '',
        deviceType: 'board' // 新增：设备类型选择，默认为智控主板
      },
      shopOptions: [],
      allShops: [],
      shopLoading: false,
      transferLoading: false,
      scanLoading: false,
      transferResult: null,
      isMobileMenuOpen: false,
      isMobile: false,
      // 验证码相关
      captchaDialogVisible: false,
      captchaCode: '',
      captchaError: '',
      dragButtonPosition: { x: 20, y: 0 }, // 初始位置
      isDragging: false,
      dragStartPos: { x: 0, y: 0 },
      startX: 0,
      startY: 0,
      hasMoved: false,
      resizeTimer: null,
      // 设备送电相关
      powerOnDialogVisible: false,
      selectedDuration: null,
      powerOnLoading: false,
      powerOnResult: null
    }
  },
  computed: {
    deviceCount() {
      if (!this.form.deviceNumbers.trim()) return 0
      return this.form.deviceNumbers
        .split('\n')
        .filter(n => n.trim())
        .length
    }
  },
  methods: {
    handleMenuSelect(index) {
      this.activeMenu = index
      this.form.shopId = ''
      this.loadShops()
    },
    selectMenu(key) {
      this.activeMenu = key
      this.form.shopId = ''
      this.closeMobileMenu()
      this.loadShops()
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      // 添加遮罩层动画类
      this.$nextTick(() => {
        const overlay = document.querySelector('.sidebar-overlay')
        if (overlay) {
          if (this.isMobileMenuOpen) {
            overlay.classList.add('show')
          } else {
            overlay.classList.remove('show')
          }
        }
      })
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      // 移除遮罩层动画类
      this.$nextTick(() => {
        const overlay = document.querySelector('.sidebar-overlay')
        if (overlay) {
          overlay.classList.remove('show')
        }
      })
    },
    checkMobile() {
      const wasMobile = this.isMobile
      this.isMobile = window.innerWidth <= 768
      
      console.log('检查移动端状态：', this.isMobile, '窗口宽度：', window.innerWidth)
      
      if (!this.isMobile) {
        this.isMobileMenuOpen = false
      } else if (!wasMobile && this.isMobile) {
        // 从PC切换到移动端时，重新初始化拖拽按钮位置
        this.$nextTick(() => {
          this.initDragButton()
        })
      }
    },
    getMenuTitle(key) {
      const source = this.menuSources.find(s => s.key === key)
      return source ? source.label : key
    },
    currentSourceLabel() {
      for (let i = 0; i < this.menuSources.length; i++) {
        if (this.menuSources[i].key === this.activeMenu) {
          return this.menuSources[i].label
        }
      }
      return ''
    },
    getResultIcon(type) {
      const icons = {
        success: 'el-icon-success',
        error: 'el-icon-error',
        warning: 'el-icon-warning'
      }
      return icons[type] || 'el-icon-info'
    },
    async loadShops() {
      try {
        this.shopLoading = true
        const params = {
          source: this.activeMenu
        }
        
        const response = await fenxShop(params)
        if (response.code === 1) {
          this.allShops = response.data || []
          this.shopOptions = this.allShops
          
          // 自动选择第一条数据
          if (this.allShops.length > 0) {
            this.form.shopId = this.allShops[0].id
          }
        } else {
          this.$message.error(response.msg || '获取店铺列表失败')
        }
      } catch (error) {
        this.$message.error('获取店铺列表失败')
      } finally {
        this.shopLoading = false
      }
    },
    searchShops(query) {
      if (query !== '') {
        const searchQuery = query.toLowerCase()
        this.shopOptions = this.allShops.filter(shop => 
          (shop.name && shop.name.toLowerCase().includes(searchQuery)) ||
          (shop.userName && shop.userName.toLowerCase().includes(searchQuery)) ||
          (shop.mobile && shop.mobile.toString().includes(searchQuery)) ||
          (shop.id && shop.id.toString().includes(searchQuery))
        )
      } else {
        this.shopOptions = this.allShops
      }
    },
    // 设备划拨：显示验证码对话框
    async handleTransfer() {
      if (!this.form.shopId) {
        this.$message.warning('请选择目标店铺')
        return
      }
      
      if (!this.form.deviceNumbers.trim()) {
        this.$message.warning('请输入设备编号')
        return
      }

      const devices = this.form.deviceNumbers
        .split('\n')
        .filter(n => n.trim())
        .map(n => n.trim())

      if (devices.length === 0) {
        this.$message.warning('请输入有效的设备编号')
        return
      }

      // 重置验证码相关数据
      this.captchaCode = ''
      this.captchaError = ''
      
      // 显示验证码对话框
      this.captchaDialogVisible = true
    },
    
    // 设备送电：显示时长选择弹窗
    async handlePowerOn() {
      if (!this.form.deviceNumbers.trim()) {
        this.$message.warning('请输入设备编号')
        return
      }

      const devices = this.form.deviceNumbers
        .split('\n')
        .filter(n => n.trim())
        .map(n => n.trim())

      if (devices.length === 0) {
        this.$message.warning('请输入有效的设备编号')
        return
      }

      // 重置相关数据
      this.selectedDuration = null
      this.captchaCode = ''
      this.captchaError = ''
      
      // 显示验证码对话框
      this.captchaDialogVisible = true
    },

    // 处理验证码弹窗关闭
    handleCaptchaClose() {
      this.captchaDialogVisible = false
      this.captchaCode = ''
      this.captchaError = ''
    },
    
    // 处理送电时长弹窗关闭
    handlePowerOnDialogClose() {
      this.powerOnDialogVisible = false
      this.selectedDuration = null
    },
    
    // 验证验证码并执行操作
    async verifyCaptchaAndTransfer() {
      // 验证验证码
      if (this.captchaCode !== '123789') {
        this.captchaError = '验证码错误，请重新输入'
        return
      }

      // 验证通过，隐藏错误提示
      this.captchaError = ''
      this.captchaDialogVisible = false

      const devices = this.form.deviceNumbers
        .split('\n')
        .filter(n => n.trim())
        .map(n => n.trim())

      // 设备划拨
      if (this.activeMenu !== 'sd') {
        try {
          this.transferLoading = true
          const response = await fenxDevice({
            source: this.activeMenu,
            deviceType:this.form.deviceType,
            shopId: this.form.shopId,
            deviceNumbers: devices
          })

          if (response.code === 1) {
              this.transferResult = {
                type: 'success',
                title: '划拨成功',
                message: `成功划拨 ${(response.data && response.data.successCount) || devices.length} 个设备`,
                details: (response.data && response.data.details) || ''
              }
              this.$message.success('设备划拨成功')
              // 成功划拨后清空设备编号
              this.form.deviceNumbers = ''
            } else {
              this.transferResult = {
                type: 'error',
                title: '划拨失败',
                message: response.message || '设备划拨失败',
                details: (response.data && response.data.details) || ''
              }
              this.$message.error(response.msg || '设备划拨失败')
            }
        } catch (error) {
          this.transferResult = {
            type: 'error',
            title: '划拨失败',
            message: '网络错误，请稍后重试',
            details: error.message || '网络错误'
          }
          this.$message.error('设备划拨失败')
        } finally {
          this.transferLoading = false
        }
      } 
      // 设备送电
      else {
        // 显示时长选择弹窗
        this.powerOnDialogVisible = true
      }
    },
    
    // 选择时长并执行送电
    async handleDurationSelect(duration) {
      this.selectedDuration = duration
      this.powerOnDialogVisible = false
      
      const devices = this.form.deviceNumbers
        .split('\n')
        .filter(n => n.trim())
        .map(n => n.trim())
      
      try {
        this.powerOnLoading = true
        // 调用设备送电接口
        const response = await batchOpen({
          deviceNumbers: devices,
          duration: duration
        })

        if (response.code === 1) {
            this.powerOnResult = {
              type: 'success',
              title: '送电成功',
              message: `成功为 ${devices.length} 个设备送电，时长 ${this.getDurationText(duration)}`,
              details: (response.data && response.data.details) || ''
            }
            this.$message.success('设备送电成功')
            // 成功送电后清空设备编号
            this.form.deviceNumbers = ''
          } else {
            this.powerOnResult = {
              type: 'error',
              title: '送电失败',
              message: response.message || '设备送电失败',
              details: (response.data && response.data.details) || ''
            }
            this.$message.error(response.msg || '设备送电失败')
          }
      } catch (error) {
        this.powerOnResult = {
          type: 'error',
          title: '送电失败',
          message: '网络错误，请稍后重试',
          details: error.message || '网络错误'
        }
        this.$message.error('设备送电失败')
      } finally {
        this.powerOnLoading = false
      }
    },
    
    // 获取时长文本
    getDurationText(duration) {
      const durationMap = {
        5: '5分钟',
        10: '10分钟',
        30: '30分钟',
        60: '1小时',
        120: '2小时',
        180: '3小时',
        240: '4小时',
        300: '5小时',
        480: '8小时',
        720: '12小时'
      }
      return durationMap[duration] || duration + '分钟'
    },
    handleReset() {
      this.form = {
        shopId: '',
        deviceNumbers: '',
        deviceType: 'board' // 重置为默认智控主板
      }
      this.transferResult = null
      this.$refs.transferForm && this.$refs.transferForm.resetFields()
      // 重置后恢复初始高度
      this.$nextTick(() => {
        this.autoResizeTextarea()
      })
    },
    
    async handleScan() {
      try {
        this.scanLoading = true
        const scanResult = await this.showScanDialog()
        
        if (scanResult) {
          // 获取现有内容
          const existingNumbers = this.form.deviceNumbers.trim()
          
          // 添加新扫描的设备编号
          if (existingNumbers) {
            this.form.deviceNumbers = existingNumbers + '\n' + scanResult
          } else {
            this.form.deviceNumbers = scanResult
          }
          
          // 自动调整文本框大小
          this.$nextTick(() => {
            this.autoResizeTextarea()
          })
          
          this.$message.success('设备编号已添加')
        }
      } catch (error) {
        console.error('扫码失败:', error)
        this.$message.error('扫码失败，请重试')
      } finally {
        this.scanLoading = false
      }
    },
    
    showScanDialog() {
      return new Promise((resolve) => {
        let html5QrCode = null
        const scanContainerId = 'qr-reader'
        
        const h = this.$createElement
        
        const dialog = this.$msgbox({
          title: '扫码添加设备',
          message: h('div', { 
            style: { 
              textAlign: 'center',
              padding: '20px'
            } 
          }, [
            h('div', {
              style: {
                marginBottom: '20px',
                fontSize: '14px',
                color: '#606266'
              }
            }, '请将二维码对准摄像头，识别后自动添加'),
            h('div', {
              attrs: { id: scanContainerId },
              style: {
                width: '100%',
                maxWidth: '400px',
                margin: '0 auto'
              }
            }),
            h('div', {
              style: {
                marginTop: '10px',
                fontSize: '12px',
                color: '#909399'
              }
            }, '请确保光线充足，二维码清晰可见')
          ]),
          showCancelButton: false,
          showConfirmButton: false,
          closeOnClickModal: true,
          beforeClose: (action, instance, done) => {
            // 停止扫码器
            if (html5QrCode) {
              html5QrCode.stop().catch(error => {
                console.error('停止扫码器失败:', error)
              })
              html5QrCode = null
            }
            done()
          }
        }).catch(() => {
          resolve(null)
        })

        // 启动真实二维码扫描
        this.$nextTick(() => {
          try {
            // 检查浏览器支持
            if (!window.Html5Qrcode) {
              this.$message.error('浏览器不支持二维码扫描功能')
              this.$msgbox.close()
              resolve(null)
              return
            }

            // 创建二维码扫描器
            html5QrCode = new window.Html5Qrcode(scanContainerId)

            // 扫描成功回调
            const onScanSuccess = (decodedText, decodedResult) => {
              console.log('二维码识别成功:', decodedText)
              
              // 停止扫描器
              if (html5QrCode) {
                html5QrCode.stop().catch(error => {
                  console.error('停止扫码器失败:', error)
                })
                html5QrCode = null
              }
              
              // 关闭消息框并返回结果
              this.$msgbox.close()
              resolve(decodedText)
            }

            // 扫描失败回调（可选，用于调试）
            const onScanFailure = (error) => {
              // 静默处理扫描失败，不显示错误信息
            }

            // 配置参数
            const config = {
              fps: 10,
              qrbox: { width: 250, height: 250 },
              aspectRatio: 1.0
            }

            // 获取摄像头列表并选择后置摄像头
            window.Html5Qrcode.getCameras()
              .then(cameras => {
                if (cameras && cameras.length > 0) {
                  console.log('可用摄像头:', cameras)
                  
                  let cameraId = cameras[0].id
                  
                  // 移动端优先选择后置摄像头
                  if (this.isMobile) {
                    // 方法1: 通过标签识别后置摄像头
                    const backCamera = cameras.find(camera =>
                      camera.label && (
                        camera.label.toLowerCase().includes('back') ||
                        camera.label.toLowerCase().includes('后置') ||
                        camera.label.toLowerCase().includes('rear') ||
                        camera.label.toLowerCase().includes('environment')
                      )
                    )
                    
                    if (backCamera) {
                      cameraId = backCamera.id
                      console.log('选择后置摄像头:', backCamera.label)
                    } else {
                      // 方法2: 如果没有明确标识，选择最后一个摄像头（通常是后置）
                      cameraId = cameras[cameras.length - 1].id
                      console.log('选择最后一个摄像头作为后置:', cameras[cameras.length - 1].label)
                    }
                  } else {
                    // 桌面端优先选择第一个摄像头
                    cameraId = cameras[0].id
                  }
                  
                  console.log('最终选择摄像头:', cameraId)
                  
                  // 启动摄像头
                  return html5QrCode.start(cameraId, config, onScanSuccess, onScanFailure)
                } else {
                  throw new Error('未找到可用摄像头')
                }
              })
              .catch(error => {
                console.error('获取摄像头失败:', error)
                this.$message.error('无法访问摄像头，请检查权限设置')
                this.$msgbox.close()
                resolve(null)
              })
            
          } catch (error) {
            console.error('二维码扫描器初始化失败:', error)
            this.$message.error('无法启动摄像头，请检查权限设置')
            this.$msgbox.close()
            resolve(null)
          }
        })
      })
    },
    
    autoResizeTextarea() {
      this.$nextTick(() => {
        const deviceInput = this.$refs.deviceInput
        if (deviceInput && deviceInput.$el) {
          const textarea = deviceInput.$el.querySelector('textarea')
          if (textarea) {
            // 重置高度以获取正确的scrollHeight
            textarea.style.height = 'auto'
            
            // 计算内容高度
            const scrollHeight = textarea.scrollHeight
            const lineHeight = 24 // 基于line-height: 1.5和font-size: 16px
            const minHeight = 120 // 原始高度的2倍
            const maxHeight = 240 // 原始高度的4倍作为上限
            
            // 根据内容行数计算高度，但限制在2-4倍原始高度之间
            let newHeight = Math.max(minHeight, scrollHeight)
            newHeight = Math.min(maxHeight, newHeight)
            
            // 设置新高度
            textarea.style.height = newHeight + 'px'
          }
        }
      })
    },
    initDragButton() {
      // 按钮已用CSS固定定位，无需JavaScript动态计算
      this.dragButtonPosition = { x: window.innerWidth - 60, y: window.innerHeight * 0.75 } // 仅用于拖拽计算参考
    },

    handleDragStart(e) {
      const button = document.querySelector('.drag-menu-button')
      if (!button) return
      
      // 获取当前按钮位置
      const rect = button.getBoundingClientRect()
      
      const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX
      const clientY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY
      
      // 标记开始拖拽，但不立即设置isDragging
      this.dragStartPos = {
        x: clientX - rect.left,
        y: clientY - rect.top
      }
      
      // 记录起始位置用于判断是否为点击
      this.startX = clientX
      this.startY = clientY
      this.hasMoved = false
    },
    handleDragMove(e) {
      const button = document.querySelector('.drag-menu-button')
      if (!button) return
      
      const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX
      const clientY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY
      
      // 计算移动距离
      const deltaX = Math.abs(clientX - this.startX)
      const deltaY = Math.abs(clientY - this.startY)
      
      // 如果移动超过5px，认为是拖拽而不是点击
      if (deltaX > 5 || deltaY > 5) {
        this.hasMoved = true
        this.isDragging = true
        
        // 计算新位置
        let newX = clientX - this.dragStartPos.x
        let newY = clientY - this.dragStartPos.y
        
        // 边界检查
        const buttonSize = 50
        const minX = 0
        const maxX = window.innerWidth - buttonSize
        const minY = 0
        const maxY = window.innerHeight - buttonSize
        
        newX = Math.max(minX, Math.min(newX, maxX))
        newY = Math.max(minY, Math.min(newY, maxY))
        
        // 更新位置
        button.style.left = newX + 'px'
        button.style.top = newY + 'px'
        
        // 同步数据
        this.dragButtonPosition = { x: newX, y: newY }
      }
      
      e.preventDefault()
    },
    handleDragEnd(e) {
      // 延迟重置拖拽状态，确保点击事件能正确触发
      setTimeout(() => {
        this.isDragging = false
      }, 100)
    },
    
    handleResize() {
      // 防抖处理，避免频繁重新计算
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        if (this.isMobile) {
          this.initDragButton()
        }
      }, 250)
    },
    handleMenuClick(e) {
      e.preventDefault()
      e.stopPropagation()
      
      // 如果是拖拽状态（移动过），不触发点击
      if (this.hasMoved) {
        return
      }
      
      // 切换菜单状态
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      
      // 强制确保移动端模式
      if (!this.isMobile) {
        this.isMobile = true
      }
      
      // 确保DOM更新后再添加遮罩层动画类
      this.$nextTick(() => {
        const overlay = document.querySelector('.sidebar-overlay')
        if (overlay) {
          if (this.isMobileMenuOpen) {
            overlay.classList.add('show')
            // 添加遮罩层点击事件监听
            overlay.addEventListener('click', this.closeMobileMenu)
          } else {
            overlay.classList.remove('show')
            // 移除遮罩层点击事件监听
            overlay.removeEventListener('click', this.closeMobileMenu)
          }
        }
      })
    }
  },
  mounted() {
    this.loadShops()
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    
    // 初始化设备输入框高度
    this.$nextTick(() => {
      setTimeout(() => {
        this.autoResizeTextarea()
      }, 100)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
    // 移除遮罩层事件监听
    const overlay = document.querySelector('.sidebar-overlay')
    if (overlay) {
      overlay.removeEventListener('click', this.closeMobileMenu)
    }
  }
}
</script>

<style scoped>
/* 设备划拨页面样式 - 确保优先级 */
.transfer-container {
  display: flex !important;
  min-height: 100vh !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  margin: 0 !important;
  padding: 0 !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
  overflow: hidden;
}

/* 左侧菜单栏 - 1/3宽度 */
.sidebar {
  width: 33.33%;
  max-width: 400px;
  min-width: 280px;
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
  border-right: 1px solid #e9ecef;
  padding: 0;
  height: 100vh;
  overflow-y: auto;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.08);
}

.sidebar-header {
  padding: 25px 20px;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  position: relative;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.sidebar-header h3 {
  color: #2c3e50;
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.sidebar-toggle {
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
}

.sidebar-menu {
  padding: 0;
  margin: 0;
  list-style: none;
}

.menu-item {
  padding: 16px 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
  position: relative;
  color: #2c3e50;
  font-weight: 500;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #f1f3f4;
  background: transparent;
}

.menu-item i {
  font-size: 16px;
  width: 20px;
  text-align: center;
}

.menu-item:hover {
  background: linear-gradient(90deg, #f8f9fa 0%, #e9ecef 100%);
  border-left-color: #3498db;
  transform: translateX(1px);
  color: #2c3e50;
}

.menu-item.active {
  background: linear-gradient(90deg, #ffffff 0%, #f8f9fa 100%);
  border-left-color: #e74c3c;
  color: #e74c3c;
  font-weight: 600;
  box-shadow: inset 3px 0 0 #e74c3c;
}

/* 右侧主内容区域 - 2/3宽度 */
.main-content {
  width: 66.67%;
  flex: 1;
  padding: 20px;
  box-sizing: border-box;
}

.header {
  margin-bottom: 30px;
  color: white;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}

.menu-toggle {
  display: none;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;
}

.header h1 {
  font-size: 32px;
  font-weight: 300;
  margin: 0;
}

.header .subtitle {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
}

.source-indicator {
  display: none;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 10px 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
}

.content {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 0 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

.transfer-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.transfer-card:hover {
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.card-header {
  text-align: center;
  margin-bottom: 35px;
  position: relative;
}

.card-header h3 {
  font-size: 26px;
  color: #2c3e50;
  font-weight: 600;
  margin: 0;
  position: relative;
}

.card-header h3::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 2px;
}

.transfer-form {
  max-width: 100%;
}

.el-form-item {
    margin-bottom: 25px;
    width: 100%;
  }

  .el-form-item:last-child {
    margin-bottom: 0;
  }

  .full-width {
    width: 100%;
  }

  .input-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-size: 14px;
    color: #666;
  }
  
  /* 移动端表单元素优化 */
  @media screen and (max-width: 768px) {
    .el-form-item {
      margin-bottom: 20px;
    }
    
    .el-select,
    .el-input {
      width: 100%;
    }
    
    .el-select .el-input__inner,
    .el-input__inner {
      height: 48px;
      font-size: 16px;
      border-radius: 10px;
      border: 2px solid #e6e6e6;
    }
    
    .el-select .el-input__inner:focus,
    .el-input__inner:focus {
      border-color: #667eea;
      box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
    }
    
    .el-form-item__label {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }
  }

.device-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
  margin: 0;
}

.device-label-group {
  display: flex;
  align-items: center;
  gap: 4px;
}

.required-mark {
  color: #ff4d4f;
  font-weight: bold;
  font-size: 14px;
  line-height: 1;
}

.device-label-text {
  font-weight: bold;
  color: #606266;
  font-size: 14px;
  line-height: 1;
}

.device-count-wrapper {
  display: flex;
  align-items: center;
  margin-left:15px;
  line-height: normal !important; /* 或者使用 1 或者 20px 等具体数值 */
}

.device-count-badge {
  color: red;
}


.device-input {
  width: 100%;
}

.input-tips {
  margin-top: 8px;
  font-size: 13px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 5px;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;
}

.transfer-btn, .reset-btn {
  min-width: 120px;
  height: 44px;
  border-radius: 22px;
  font-size: 16px;
}

.shop-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.shop-name {
  font-weight: 500;
}

.shop-id {
  color: #999;
  font-size: 12px;
}

.result-card {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  animation: fadeInUp 0.5s ease;
  border-left: 6px solid #667eea;
  margin-top: 20px;
}

.result-header {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.result-header i {
  font-size: 24px;
}

.result-header i.el-icon-success {
  color: #67c23a;
}

.result-header i.el-icon-error {
  color: #f56c6c;
}

.result-header i.el-icon-warning {
  color: #e6a23c;
}

.result-content {
  color: #666;
  line-height: 1.6;
  font-size: 16px;
}

.result-details {
  margin-top: 20px;
}

.result-details pre {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  font-size: 14px;
  color: #666;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #e6e6e6;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 移动端遮罩层 */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  z-index: 1999;
  backdrop-filter: blur(0px);
  -webkit-backdrop-filter: blur(0px);
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  pointer-events: none;
}

.sidebar-overlay.show {
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  pointer-events: auto;
}

/* 移动端优化 - 现代化滑出式菜单 */
  @media screen and (max-width: 768px) {
    .transfer-container {
      flex-direction: column;
      min-height: 100vh;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      padding: 0;
      margin: 0;
      position: relative;
    }
    
    /* 隐藏PC端菜单 */
    .sidebar {
      display: none;
    }
    
    /* 移动端专用滑出菜单 */
    .sidebar {
      position: fixed;
      left: 0;
      top: 0;
      width: 280px;
      height: 100vh;
      z-index: 2000;
      transform: translateX(-100%);
      transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      display: block !important;
    }
    
    .sidebar.open {
      transform: translateX(0);
    }
    
    .sidebar-header {
      padding: 25px 20px;
      background: linear-gradient(135deg, #1a252f 0%, #2c3e50 100%);
      color: white;
      text-align: center;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
    
    .sidebar-header h3 {
      font-size: 20px;
      font-weight: 600;
      margin: 0;
      color: white;
    }
    
    .menu-item {
        padding: 18px 25px;
        color: #ecf0f1;
        font-size: 16px;
        border-bottom: 1px solid #34495e;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 15px;
        transition: all 0.2s ease;
      }

      .menu-item i {
        font-size: 18px;
        width: 24px;
        text-align: center;
      }
    
    .menu-item:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    
    .menu-item.active {
      background: linear-gradient(90deg, #3498db 0%, #2980b9 100%);
      color: white;
      border-left: 4px solid #3498db;
      font-weight: 600;
      box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    }
    
    .menu-icon {
      font-size: 18px;
      width: 24px;
      text-align: center;
    }
    
    /* 汉堡菜单按钮 */
    .sidebar-toggle {
      display: flex !important;
      position: fixed;
      top: 15px;
      left: 15px;
      z-index: 2001;
      background: rgba(255, 255, 255, 0.95);
      color: #667eea;
      border: none;
      border-radius: 50%;
      width: 45px;
      height: 45px;
      cursor: pointer;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      backdrop-filter: blur(10px);
    }
    
    .sidebar-toggle:hover {
      transform: scale(1.1);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }
    
    .hamburger-line {
      display: block;
      width: 20px;
      height: 2px;
      background: #667eea;
      margin: 3px 0;
      transition: all 0.3s ease;
      border-radius: 2px;
    }
    
    .main-content {
      width: 100%;
      padding: 15px 15px 60px; /* 调整内边距 */
      margin-top: 0;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center; /* 水平居中 */
    }
    
    /* 移动端content元素水平居中 */
    .content {
      width: 100%;
      max-width: 600px;
      margin: 0 auto;
      padding: 0 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    
    .main-content.has-menu {
      padding-top: 60px;
    }
    
    .header {
      margin-bottom: 20px; /* 调整底部间距 */
      color: white;
      text-align: center;
      width: 100%;
    }
    
    .header h1 {
      font-size: 28px; /* 调整字体大小 */
      color: white;
      font-weight: 500;
      margin-bottom: 10px; /* 调整底部间距 */
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  
  
  .transfer-card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    padding: 25px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    margin-bottom: 20px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 500px;
  }
  
  /* 移动端设备输入框高度优化 */
  .device-input {
    min-height: 140px; /* 增加输入框最小高度 */
  }

  .device-header-row {
    padding: 0;
  }

  .device-label-group {
    gap: 2px;
  }

  .required-mark {
    font-size: 14px;
  }

  .device-label-text {
    font-size: 14px;
  }

  .device-count-badge {
    font-size: 11px;
    padding: 3px 8px;
    border-radius: 10px;
    background-color: #ff4d4f;
    color: white;
    font-weight: 600;
  }

  .device-input textarea {
    min-height: 140px; /* 增加输入框最小高度 */
    max-height: 280px; /* 增加最大高度上限 */
    font-size: 16px;
    line-height: 1.5;
    resize: vertical;
    overflow-y: auto; /* 当内容超出max-height时显示滚动条 */
    transition: height 0.2s ease;
    box-sizing: border-box;
    border-radius: 10px;
    border: 2px solid #e6e6e6;
  }

  .device-input textarea:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
  }

  /* 设备类型单选框样式 */
  .device-type-group {
    display: flex;
    gap: 20px;
  }

  .device-type-radio {
    display: flex;
    align-items: center;
    margin-right: 0;
    padding: 10px 15px;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .device-type-radio:hover {
    border-color: #409eff;
    background-color: #f5f7fa;
  }

  .device-type-radio.is-checked {
    border-color: #409eff;
    background-color: #ecf5ff;
  }

  .device-type-radio .el-radio__label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #606266;
  }

  .device-type-radio .el-icon-s-grid,
  .device-type-radio .el-icon-lock {
    font-size: 16px;
    color: #409eff;
  }

  /* 店铺选项样式优化 */
  .shop-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
  }

  .shop-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .shop-name {
    font-weight: 600;
    color: #303133;
    font-size: 14px;
  }

  .shop-user,
  .shop-phone {
    font-size: 12px;
    color: #909399;
    margin-left: 0;
  }

  .shop-id {
  font-size: 12px;
  color: #c0c4cc;
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 4px;
}

.loading-empty {
  text-align: center;
  padding: 20px 0;
  color: #909399;
}

.loading-empty i {
  margin-right: 8px;
  font-size: 16px;
}

/* 移动端适配 */
  @media screen and (max-width: 768px) {
    .shop-option {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      padding: 8px 12px;
    }
    
    .shop-info {
      flex: 1;
      min-width: 0;
    }
    
    .shop-name {
      font-size: 14px;
      font-weight: 500;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
    }
    
    .shop-user,
    .shop-phone {
      font-size: 12px;
      color: #666;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
    }
    
    .shop-id {
      font-size: 11px;
      padding: 1px 4px;
      background: #f0f2f5;
      color: #666;
      flex-shrink: 0;
    }
  }

  /* 移动端适配 */
  @media screen and (max-width: 768px) {
    .device-type-group {
      flex-direction: row;
      gap: 8px;
      justify-content: space-between;
    }
    
    .device-type-radio {
      margin-right: 0;
      flex: 1;
      justify-content: center;
      min-width: 0;
      padding: 8px 4px;
      font-size: 14px;
    }
    
    .device-type-radio .el-icon {
      margin-right: 4px;
      font-size: 14px;
    }
    
    .device-type-radio span {
      font-size: 13px;
    }
  }
  
  .card-header h3 {
    font-size: 22px;
    color: #333;
    font-weight: 600;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }
  
  .transfer-btn,
  .reset-btn {
    width: 100%;
    margin: 0;
    padding: 16px;
    font-size: 17px;
    border-radius: 25px;
    font-weight: 600;
    transition: all 0.3s ease;
  }
  
  .transfer-btn {
    background: linear-gradient(135deg, #667eea, #764ba2);
    border: none;
    color: white;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  }
  
  .transfer-btn:hover {
    background: linear-gradient(135deg, #5a6fd8, #6a4190);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
    transform: translateY(-2px);
  }
  
  .reset-btn {
    background: white;
    border: 2px solid #e6e6e6;
    color: #666;
  }
  
  .reset-btn:hover {
    border-color: #667eea;
    color: #667eea;
  }
  
  .sidebar-overlay {
    display: block !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1999;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    backdrop-filter: blur(4px);
  }
  
  .sidebar-overlay.show {
    opacity: 1;
    visibility: visible;
  }

  /* 拖拽菜单按钮 */
  .drag-menu-button {
      position: fixed;
      right: 10px;
      bottom: 25vh;
      width: 50px;
      height: 50px;
      background: linear-gradient(135deg, #667eea, #764ba2);
      color: white;
      border: none;
      border-radius: 50%;
      cursor: move;
      z-index: 2100; /* 提高层级，确保在侧边栏之上 */
      box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      user-select: none;
      -webkit-user-select: none;
      -webkit-tap-highlight-color: transparent;
      touch-action: none; /* 防止触摸事件冲突 */
    }
    
    .drag-menu-button i {
      font-size: 20px;
      font-weight: bold;
    }
  
  .drag-menu-button:hover {
      background: linear-gradient(135deg, #5a6fd8, #6a4190);
      box-shadow: 0 6px 25px rgba(102, 126, 234, 0.6);
      transform: scale(1.05);
      margin-right: -20px; /* 悬停时更多露出 */
    }
    
    .drag-menu-button.dragging {
      background: linear-gradient(135deg, #4f5fc6, #5d3780);
      box-shadow: 0 8px 30px rgba(102, 126, 234, 0.8);
      cursor: grabbing;
      transform: scale(1.1);
    }
    
    .drag-menu-button:active {
      transform: scale(0.95);
    }
}

/* 扫码添加按钮样式 */
.scan-section {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.scan-section .device-input {
  flex: 1;
  margin-bottom: 0;
}

.scan-section .el-button {
  height: 40px;
  white-space: nowrap;
}

/* 扫码对话框样式 */
.scan-dialog .el-dialog__body {
  padding: 20px;
  text-align: center;
}

#qr-reader {
  width: 100%;
  max-width: 400px;
  margin: 0 auto 20px;
}

#qr-reader video {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

/* 超小屏幕优化 */
@media screen and (max-width: 480px) {
  .sidebar {
    width: 260px;
  }
  
  .sidebar-toggle {
    top: 15px;
    left: 15px;
    width: 45px;
    height: 45px;
  }
  
  .hamburger-line {
    width: 18px;
    margin: 2.5px 0;
  }
  
  /* 优化移动端布局 - 去掉背景内容向上移动，调整左右边缘缩进 */
  .main-content {
    padding: 10px 15px 50px; /* 减小内边距，增加左右缩进 */
    margin-top: 0;
  }
  
  .main-content.has-menu {
    padding-top: 60px;
  }
  
  /* 移除页面背景，使内容更聚焦 */
  body {
    background: #ffffff;
  }
  
  .header {
    margin-bottom: 12px;
  }
  
  .header h1 {
    font-size: 20px;
    margin-bottom: 6px;
  }
  
  .subtitle {
    font-size: 13px;
    margin-bottom: 4px;
  }
  
  .transfer-card {
    padding: 15px;
    border-radius: 12px;
    margin-bottom: 10px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    background: #ffffff;
  }
  
  .card-header h3 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  
  .source-indicator {
    padding: 6px 10px;
    font-size: 12px;
    margin-bottom: 12px;
    border-radius: 20px;
  }
  
  .el-form-item {
    margin-bottom: 10px;
  }
  
  .action-buttons {
    gap: 10px;
  }
  
  .transfer-btn,
  .reset-btn {
    padding: 12px;
    font-size: 14px;
    border-radius: 20px;
  }
  
  /* 移动端content更紧凑 */
  .content {
    padding: 0 8px;
    max-width: 100%;
  }
  
  /* 设备输入框移动端优化 */
  .device-input {
    min-height: 100px;
  }
  
  .device-input textarea {
    min-height: 100px;
    font-size: 15px;
  }
  
  /* 扫码按钮移动端优化 */
  .scan-section {
    flex-direction: column;
    gap: 8px;
  }
  
  .scan-section .device-input {
    width: 100%;
  }
  
  .scan-section .el-button {
    width: 100%;
    height: 36px;
    font-size: 13px;
  }
  
  /* 移动端下拉框和布局优化 */
@media screen and (max-width: 480px) {
    /* 下拉框弹出层优化 */
    .el-select-dropdown {
      max-width: calc(100vw - 30px) !important;
      left: 15px !important;
      right: 15px !important;
      margin: 0 !important;
    }
    
    .el-select-dropdown__item {
      padding: 6px 8px;
      line-height: 1.3;
    }
    
    .el-select-dropdown__item.selected::after {
      right: 8px;
    }
    
    /* 设备类型单选框进一步优化 */
    .device-type-group {
      gap: 2px;
    }
    
    .device-type-radio {
      padding: 4px 2px;
      font-size: 12px;
    }
    
    .device-type-radio .el-icon {
      margin-right: 2px;
      font-size: 12px;
    }
    
    .device-type-radio span {
      font-size: 11px;
    }
    
    /* 表单元素间距优化 */
    .el-form-item {
      margin-bottom: 10px;
    }
    
    .el-form-item__label {
      font-size: 13px;
      margin-bottom: 4px;
    }
    
    .el-input__inner,
    .el-textarea__inner {
      font-size: 14px;
    }
    
    /* 操作结束弹框优化 - 直接展示在页面中间 */
    .el-message-box {
      width: calc(100vw - 30px) !important;
      max-width: 90vw;
      left: 50% !important;
      top: 50% !important;
      transform: translate(-50%, -50%) !important;
      margin: 0 !important;
      padding: 15px;
    }
    
    .el-message-box__content {
      padding: 10px 0;
    }
    
    /* 普通消息提示优化 */
    .el-message {
      left: 50% !important;
      transform: translateX(-50%);
      width: auto;
      max-width: calc(100vw - 30px);
      margin: 0;
    }
  }
  
  /* 时长选择弹窗样式 */
  .duration-dialog {
    padding: 20px 0;
  }
  
  .duration-options {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 15px;
  }
  
  .duration-option {
    padding: 15px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    background-color: #ffffff;
  }
  
  .duration-option:hover {
    border-color: #409eff;
    background-color: #ecf5ff;
  }
  
  .duration-option:active {
    transform: scale(0.98);
  }
  
  /* 移动端适配 */
  @media (max-width: 768px) {
    .duration-options {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }
    
    .duration-option {
      padding: 12px 8px;
      font-size: 13px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/device/Transfer.vue